<template>
    <div>
        <config-main-title>Enquetes</config-main-title>

        <template v-if="!modelo">

            <div class="row mb-3">
            
                <div class="col col-12 col-md-9">
                    <az-input 
                        ref="pesquisa"
                        placeholder="Pesquisar..."
                        icon="fas fa-search fa-fw"
                        v-model="search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-primary" @click="incluir()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>

                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

        </template>

        <template v-if="!modelo && ( !lista || !lista.length )">
            <az-empty-state icon="fa-solid fa-clipboard-list" msg="Nenhuma enquente criada." />
        </template>

        <template v-else>

            <div class="mb-2 text-right" v-if="lista_tags && lista_tags.length">
                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                        v-for="(tag, itx) in lista_tags" :key="itx">
                    <span class="badge badge-success mr-1" >
                        {{ tag }}
                    </span>
                </a>
            </div>

            <div id="impressao">

                <ul class="list-group" v-if="!modelo && lista">
                    <li class="list-group-item d-flex justify-content-between" v-for="(item, index) in lista" :key="index">
                        <a href="#" @click.prevent="selecionar(item)" class="card-link">
                            {{ item.st_titulo }}
                            <span class="badge badge-secondary">#{{ item.id_enquete }}</span>
                        </a>

                        <div class="custom-control custom-switch ml-3" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + index"  v-model="item.fl_ativo" @change="toggle(item)">
                            <label class="custom-control-label" :for="'ativo-' + index"></label>
                        </div>
                        <div v-else>
                            <span v-if="item.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in item.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>
                        </div>
                    </li>
                </ul>

            </div>

            <div class="card" v-if="modelo">
                <div class="card-header">
                    {{ modelo.st_titulo }}
                    <span class="badge badge-secondary ml-3">#{{ modelo.id_enquete }}</span>
                </div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-9">
                            <az-input label="Título" 
                                required 
                                :validate="validate"
                                v-model="modelo.st_titulo" 
                                type="text" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                label="Origem" 
                                required 
                                :validate="validate"
                                v-model="modelo.model_type" 
                                type="select"
                                :optionsList="lista_models" 
                                optionsData="id" />

                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col col-12">
                            <az-input 
                                label="Observações"
                                type="textarea"
                                rows="3"
                                v-model="modelo.st_observacoes" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <small class="text-muted">Classificação</small>
                            <multiselect
                                v-model="modelo.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma classificação criada.
                                </template>
                            </multiselect>
                        </div>
                    </div>

                    <h3 class="alert alert-dark mt-3">Formulário</h3>
                    <div class="form-row" v-if="false">
                        <div class="col col-12 col-md-4">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Compacto"
                                v-model="modelo.fl_compact" />
                        </div>
                    </div>

                    <formulario 
                        :compact="modelo.fl_compact"
                        :enquete="true"
                        v-model="modelo.js_formulario" 
                        v-if="modelo" 
                        :saved="saved" 
                        :config="true" 
                        @atualizar="atualizar()"/>

                    <h3 class="alert alert-dark mt-3">Avaliação</h3>

                    <div class="form-row" v-for="(avaliacao, iax) in modelo.js_avaliacao" :key="iax">
                        <div class="col col-12 col-md-4">
                            <az-input
                                sizing="sm"
                                placeholder="Resultado..."
                                required
                                :validate="validate"
                                v-model="avaliacao.resultado">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-danger" type="button" @click="remover_avaliacao(iax)">
                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                sizing="sm"
                                placeholder="Cor..."
                                type="select"
                                :optionsList="[
                                    { id: 'primary', search: 'Azul' },
                                    { id: 'success', search: 'Verde' },
                                    { id: 'danger', search: 'Vermelho' },
                                    { id: 'dark', search: 'Preto' },
                                    { id: 'secondary', search: 'Cinza' },
                                    { id: 'warning', search: 'Amarelo' },
                                    { id: 'info', search: 'Ciano' },
                                ]"
                                optionsData="id"
                                :validate="validate"
                                v-model="avaliacao.cor">
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input   
                                type="number"
                                placeholder="De..."
                                sizing="sm"
                                icon="fa-solid fa-greater-than-equal"
                                v-model="avaliacao.de" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input   
                                type="number"
                                placeholder="Até..."
                                sizing="sm"
                                icon="fa-solid fa-less-than-equal"
                                v-model="avaliacao.ate" />
                        </div>
                    </div>

                    <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_avaliacao()">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>

                    <hr>

                </div>
            </div>

            <div v-if="modelo">
            
                <br><br><br>
            
                <nav class="navbar fixed-bottom navbar-light bg-light" >
                    <div>
                        <az-submit class="mr-2" @click="atualizar ()">Atualizar</az-submit>
                        <button class="btn btn-secondary mr-2" type="button" @click="fechar()">Fechar</button>
                        <az-audit-log-button model="modeloProntuario" :id="modelo.id_modelo_prontuario" />
                    </div>
                </nav>

            </div>

        </template>
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            modelos: [],
            modelo: null,
            saved: true,
            procedimentos: null, 
            medicoUnidade: null, 
            vinculoProcedimento: "", 
            viewMode: "A",
            id_medico: null, 
            medico: "", 
            bc: [],
            search: "", 
            options_classes: [], 
            novoCampo: "", 
            lista_selecao: null, 
            medico_unidade: null, 
            validate: false, 
            novo_proc: null, 
        }
    },
    
    components: { 
        AzInput,
        Formulario,
        ConfigMainTitle, 
        AzEmptyState, 
        AzSubmit, 
        AzAuditLogButton, 
        Multiselect,  
    },

    props: ['id'],
    
    computed: { 
        lista: function () { 
            let reg = this.$util.getregex(this.search);
            
            return this.modelos.filter(item => this.viewMode == 'T' || item.fl_ativo)
                .filter(item => !this.search || reg.test(JSON.stringify(item)) );
        },

        lista_tags: function () { 
            if ( !this.modelos )
                return [];

            return  _.orderBy(
                _.uniq(
                    this.modelos.reduce((carry, item) => { 
                        return item.js_classes ? carry.concat(item.js_classes) : carry;
                    }, [])
                )
            );
        },

        procedimentos_com_modelo: function() { 
            if ( !this.procedimentos )
                return [];

            return this.procedimentos.filter(item => item.id_modelo_prontuario);
        },

        lista_campos: function () { 
            if ( !this.modelo || !this.modelo.estrutura )
                return [];

            let valores = this.modelo.estrutura;
      
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);

            return valores.filter(campo => campo.id)
                .map(campo => { 
                    campo.search = ( campo.label ? campo.label : 'Sem Título' ) + " (#" + campo.id + ")";
                    return campo;
                });
        },

        lista_models: function () { 
            return [
                { id: 'App\\azure\\apoiado', search: 'Apoiado' }, 
                { id: 'App\\azure\\atendimento', search: 'Atendimento' }, 
                { id: 'App\\azure\\fornecedor', search: 'Fornecedor' }, 
                { id: 'App\\azure\\estoqueNotaFiscal', search: 'Nota Fiscal (Suprimentos)' }, 
                { id: 'App\\azure\\operadora', search: 'Operadora' }, 
                { id: 'App\\azure\\medico', search: 'Prestador' }, 
                { id: 'App\\azure\\medicoSolicitante', search: 'Profissional Solicitante' }, 
            ];
        }, 

        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        remover_avaliacao (index) { 
            this.modelo.js_avaliacao.splice(index, 1);
        },

        incluir_avaliacao () { 
            this.modelo.js_avaliacao.push({
                de: "",
                ate: "",
                resultado: "", 
                cor: "", 
            });
        },

        selecionar_modelo_procedimento () { 
            
            if ( this.novo_proc ) { 

                let item = this.procedimentos.find(pc => pc.id_medico_procedimento_unidade == this.novo_proc.id_medico_procedimento_unidade)

                this.selecionar_modelo_medico(item, null, item.procedimento);

                this.$nextTick(() => { 
                    this.novo_proc = ""; 
                });

            }

        },

        acessos (modelo) { 
            this.$refs.acessos.abrir('App\\azure\\modeloProntuario', modelo.id_modelo_prontuario);
        },

        incluir_novo_campo() {
            if ( !this.novoCampo )
                return;

            this.modelo.st_layout_impressao = this.modelo.st_layout_impressao + ' #' + this.novoCampo;

            this.novoCampo = null;

            this.$nextTick(() => {
                this.novoCampo = "";
            });
        },

        enviar_arquivo() {
            this.$refs.upload.abrir();
        },

        refresh_arquivos() { 
            this.load();
            this.$util.loadItem(this, { 
                service: 'modelos',
                func: 'show',
                id: this.modelo.id_modelo_prontuario,
            })
            .then(res => { 
                this.modelo.arquivos = res.arquivos;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });
        },
        
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.modelo.js_classes )
                this.modelo.js_classes = [];

            this.modelo.js_classes.push(newTag);
        },

        atualizar_lista_procedimento (lista) { 
            this.modelo.procedimento_lista = lista;
        },

        editar_lista_procedimentos(modelo) { 
            this.$refs.proclista.abrir('modeloProntuario', modelo.id_modelo_prontuario);
        },

        pesquisar() { 
            //
        },

        fechar() { 
            this.modelo = null;

            this.bc = this.bc.slice(0, 2);
            this.$store.commit('setBreadcrumb', this.bc);

            this.$router.replace({ name: 'enquetes' });
        },

        toggle(item) { 
            this.$util.toggle(this, { 
                service: 'enquetes',
                dados: item, 
            });
        },

        selecionar (modelo) { 

            this.validate = false;

            this.$util.load(this, { 
                service: 'enquetes',
                func: 'show',
                parms: { 
                    id: modelo.id_enquete,
                    cadastro: true, 
                },
                loadTo: res => { 
                    if ( res && !res.js_avaliacao ) { 
                        res.js_avaliacao = [];
                    }
                        
                    this.modelo = res;
                    this.$router.replace({ name: 'enquetes', params: { id: this.modelo.id_enquete }});

                    this.bc = this.bc.slice(0,2);

                    this.bc.push({ 
                        name: this.modelo.st_titulo, 
                        path: "/modelos", 
                        route_name: "modelos",  
                        params: { 
                            id: this.modelo.id_enquete 
                        } 
                    });

                    this.$store.commit('setBreadcrumb', this.bc);
                }
            })
            
        },

        load () { 
            this.$store.commit('loading', true);
            
            let query = { q: [
                { 
                    name: 'enquetes.index',
                    id: 'enquetes',
                    parms: { 
                       cadastro: true, 
                    },
                },
            ]};

            this.axios.post('/aql?a=enquetes.index', query)
                .then(res => { 
                    if ( res.data.enquetes.status == 200 ) { 
                        this.modelos = res.data.enquetes.data;
                    }

                    if ( this.id ) { 
                        this.selecionar(this.modelos.find(item => item.id_enquete == this.id));
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        excluir(modelo) { 
            console.log(modelo);
            alert('Em desenvolvimento...');
        },

        abrir () { 
            $('#formularioConfigModal').modal('show');
        },

        incluir () { 
            this.modelo = { 
                id_enquete: null, 
                fl_ativo: true, 
                st_titulo: "Enquete",
                fl_compact: false, 
                js_formulario: [],
                js_classes: [], 
                st_observacoes: "", 
                model_type: "", 
                js_avaliacao: [], 
            };
        },

        atualizar () { 

            if ( this.modelo.js_avaliacao && this.modelo.js_avaliacao.length ) { 
                this.modelo.js_avaliacao = _.orderBy(this.modelo.js_avaliacao, 'de');
            }

            let query = { q: [
                { 
                    name: 'enquetes.store',
                    id: 'modelo',
                    parms: { 
                        ...this.modelo, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.modelo.status == 200 ) { 

                        if ( !this.modelo.id_enquete ) { 
                            this.modelo.id_enquete = res.data.modelo.data.id_enquete;
                        }

                        this.load ();
                        this.$toast.add({
                            severity: "success",
                            summary: "Enquete Atualizada!",
                            detail: res.data.modelo.data.st_titulo,
                            life: 3000
                        });

                    }
                });

        }
    },

    created() { 
        if ( this.$store.state.user.medico ) { 
            this.id_medico = this.$store.state.user.id_pessoa;
        }
    },

    mounted () { 
        this.bc = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Enquetes", method: this.fechar }
        ];

        this.$store.commit("setBreadcrumb", this.bc);

        /*
        if ( this.id ) { 
            this.$router.replace({ name: 'modelos' });
        }
        */

        this.$refs['pesquisa'].$refs.input.focus ();

        this.load ();

        this.$util.loadItem(this, { 
            service: 'enquetes',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>